import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// تحقق عام بلا تسجيل دخول — لذلك لا يستخدم عميل المصادقة.
export const verifySeal = async (hash) => (await axios.get(`${API}/api/verify/seal/${hash}`)).data;

export const sealQrUrl = (hash) => `${API}/api/verify/seal/${hash}/qr.png?scale=6`;
